"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicQueryOperator = void 0;
var DynamicQueryOperator;
(function (DynamicQueryOperator) {
    DynamicQueryOperator["Between"] = "between";
    DynamicQueryOperator["BetweenWithNull"] = "betweenn";
    DynamicQueryOperator["BitwiseOr"] = "bor";
    DynamicQueryOperator["BitwiseOrWithNull"] = "born";
    DynamicQueryOperator["Equals"] = "eq";
    DynamicQueryOperator["GreaterThan"] = "gt";
    DynamicQueryOperator["GreaterThanOrEqualTo"] = "gte";
    DynamicQueryOperator["In"] = "in";
    DynamicQueryOperator["Inn"] = "inn";
    DynamicQueryOperator["IsNull"] = "isnull";
    DynamicQueryOperator["LessThan"] = "lt";
    DynamicQueryOperator["LessThanOrEqualTo"] = "lte";
    DynamicQueryOperator["Like"] = "like";
    DynamicQueryOperator["NotEqual"] = "ne";
    DynamicQueryOperator["NotIn"] = "notin";
    DynamicQueryOperator["NotLike"] = "notlike";
    DynamicQueryOperator["NotNull"] = "notnull";
})(DynamicQueryOperator || (exports.DynamicQueryOperator = DynamicQueryOperator = {}));
//# sourceMappingURL=DynamicQueryOperator.js.map